import cn from 'classnames';
import { faTh } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState, useRef, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { RoleImage } from './RoleImage';
import useOnClickOutside from '../../../hooks/useOnClickOutside';

import { RETAILER, SUPPLIER } from '../../../constants/roles';
import { getRoles, setRolesRole } from '../../../store/actions/roles';

import styles from './Roles.module.scss';

export function Roles() {
  const dispatch = useDispatch();
  const rootElement = useRef(null);
  const [show, setShow] = useState(false);
  const { user, currentRole, retailerId, supplierId } = useSelector((state) => state.role);
  const { retailers = [], suppliers = [] } = user || {};

  const sortedSuppliers = [...suppliers].sort((supplierA, supplierB) => supplierA.name.localeCompare(supplierB.name));
  const sortedRetailers = [...retailers].sort((retailerA, retailerB) => retailerA.name.localeCompare(retailerB.name));
  const accountsCount = suppliers.length + retailers.length;

  const currentAccount = useCallback(
    (roleId) => {
      if (currentRole === SUPPLIER) return roleId === supplierId;
      if (currentRole === RETAILER) return roleId === retailerId;
      return false;
    },
    [currentRole, supplierId, retailerId],
  );

  useEffect(() => {
    if (accountsCount === 0) {
      getRoles();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useOnClickOutside(
    rootElement,
    useCallback(() => {
      setShow(false);
    }, []),
  );

  const changeRole = (e, accountId, type) => {
    e.stopPropagation();
    dispatch(setRolesRole(accountId, type));
    setShow(false);
  };

  const renderAccount = (account, type) => {
    const { id, name, square_logo_path } = account;
    return (
      <li
        key={name}
        title={name}
        onClick={(e) => changeRole(e, id, type)}
        className={currentAccount(id) ? styles.active : ''}
      >
        <RoleImage src={square_logo_path} alt={name} size={32} />
        {name}
      </li>
    );
  };

  if (!accountsCount) {
    return null;
  }

  return (
    <div className={styles.rolesWrapper} onClick={() => setShow((currentShow) => !currentShow)} ref={rootElement}>
      <div className={cn('ic-dashboard', styles['ic-dashboard'])}>
        <FontAwesomeIcon icon={faTh} />
      </div>

      <div className={cn(styles.roles, show ? styles.shown : '')}>
        <div className={styles.accountsWrapper}>
          <ul>
            {sortedSuppliers.map((supplier) => renderAccount(supplier, SUPPLIER))}
            {sortedSuppliers.length > 0 ? <li className={styles.separator}></li> : null}
            {sortedRetailers.map((retailer) => renderAccount(retailer, RETAILER))}
          </ul>
        </div>
      </div>
    </div>
  );
}
